/** Appearance preference for YogaKai — light, dark, or follow the device. */

export const THEME_KEY = 'yogakai.theme';
export const THEME_OPTIONS = [
  { id: 'light', label: 'Light' },
  { id: 'dark', label: 'Dark' },
  { id: 'system', label: 'System' },
];

const ALLOWED = new Set(THEME_OPTIONS.map((o) => o.id));

export function readThemePreference() {
  try {
    const v = localStorage.getItem(THEME_KEY);
    if (ALLOWED.has(v)) return v;
  } catch {
    /* private mode */
  }
  return 'light';
}

export function applyTheme(preference) {
  const theme = ALLOWED.has(preference) ? preference : 'light';
  if (typeof document === 'undefined') return theme;
  document.documentElement.dataset.theme = theme;
  return theme;
}

export function setThemePreference(preference) {
  const theme = ALLOWED.has(preference) ? preference : 'light';
  try {
    localStorage.setItem(THEME_KEY, theme);
  } catch {
    /* private mode */
  }
  return applyTheme(theme);
}

export function initTheme() {
  return applyTheme(readThemePreference());
}
